<template>
    <div class="course-container">
        <h2 class="title">download</h2>
        <div class="course-list">
            <div v-for="course in courses" :key="course.id" class="course-card">
                <!-- 课程图片 -->
                <img @click="goToDetail(course.id)" :src="course.image" :alt="course.title" class="course-image" />
                <!-- 进度条 -->
                <el-progress :percentage="course.progress" :stroke-width="6" color="#409eff" class="progress-bar"
                    :show-text="false"></el-progress>
                <!-- 课程信息 -->
                <div style="display: flex;align-items: center; justify-content: space-around;">
                    <div>
                        <h3 class="course-title">{{ course.title }}</h3>
                        <p class="course-progress">
                            <!-- <span class="bold-text">COMPLETE</span> -->
                        </p>
                    </div>
                    <el-button size="mini" type="info" round>Download</el-button>
                </div>
            </div>      
        </div>
    </div>
</template>

<script>
export default {
    name: "curriculum-index",
    data() {
        return {
            courses: [
                {
                    id: 1,
                    title: "Test Course",
                    image: "https://static-cse.canva.cn/blob/335152/.png",
                    progress: 0,
                },
                {
                    id: 2,
                    title: "Drip Course",
                    image: "https://static-cse.canva.cn/blob/335152/.png",
                    progress: 33,
                },
                {
                    id: 3,
                    title: "Custom Course",
                    image: "https://static-cse.canva.cn/blob/335152/.png",
                    progress: 0,
                },
            ],
        };
    },
    methods: {
        goToDetail(id) {
            this.$router.push(`/curriculum/detail/${id}`); // ✅ 编程式跳转
        }
    }
};
</script>
<style scoped>
.course-container {
    padding: 20px;
    background-color: #f5f5f5;
    /* min-height: 100vh; */
}

.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.course-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.course-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    width: 240px;
    text-align: center;
}

.course-image {
    width: 100%;
    height: 230px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
}

.progress-bar {
    margin: 12px 0;
}

.course-title {
    font-size: 16px;
    font-weight: bold;
    margin-top: 6px;
}

.course-progress {
    font-size: 14px;
    color: #666;
}

.bold-text {
    font-weight: bold;
}
</style>